import styled from 'styled-components';

export const Container = styled.div`
  padding: 50px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
